const level = [
  [ 0,   0,   0,   0,   0,   0,   0,   0,   0,   0],
  [ 0,   0,   0,  99,  99,  99,  99,  99,   0,   0],
  [ 0,   0,  99,  99,   0,  38,  64,  99,   0,   0],
  [ 0,   0,  99,   0,   7,   0,  51,  99,   0,   0],
  [ 0,   0,  99,   0,   9,   8,   0,  99,   0,   0],
  [ 0,   0,  99,  52,   0,   0,   0,  99,   0,   0],
  [ 0,   0,  99,  99,  99,  99,  99,  99,   0,   0],
  [ 0,   0,   0,   0,   0,   0,   0,   0,   0,   0],

]

export default level